.root {
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.iconWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  background: var(--color-brand-secondary-soft);
  flex-shrink: 0;
}

.icon {
  font-size: 18px;
  color: var(--color-brand-secondary);
}

.eyebrow {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--color-text-tertiary);
  text-transform: uppercase;
}

.title {
  font-size: 15.5px;
  font-weight: 700;
  color: var(--color-text);
  margin-top: 2px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13.5px;
  color: var(--color-text-secondary);
  line-height: 1.45;
}

.check {
  font-size: 15px;
  color: var(--color-brand-secondary);
  flex-shrink: 0;
  margin-top: 1px;
}
